import React from 'react';
import { Dialog } from '@mui/material';
import styles from "../styles.module.scss"
import ALoader from '../../../../common/a-loader';

const CreatingReceiptDailog = ({ open }) => {

    return (

        <Dialog open={open}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "414px",
                    },
                },
            }}
        >

            <div className={`d-flex flex-column justify-content-between align-items-center ${styles['dialog-padding']}`}>

                <ALoader position="static" />
                <div className={` mt-3 ${styles['verify-details-dialog-header']}`}>Receipt creation is in process..</div>
                <div className={`${styles['cancel-collection-dialog-sub-header']}`}>Please wait and don’t close the window</div>

            </div>

        </Dialog>
    );
}

export default CreatingReceiptDailog;